import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  open(event) {
    event.preventDefault()
    this.containerTarget.classList.remove('hidden')
    document.body.style.overflow = 'hidden'
  }

  close(event) {
    if (event) event.preventDefault()
    this.containerTarget.classList.add('hidden')
    document.body.style.overflow = 'auto'
  }

  closeOnBackdrop(event) {
    if (event.target === this.containerTarget) {
      this.close(event)
    }
  }

  switchTab(event) {
    event.preventDefault()
    const tabValue = event.currentTarget.dataset.tab

    // Hide all tab panels
    this.element.querySelectorAll('.tab-panel').forEach(panel => {
      panel.classList.add('hidden')
    })

    // Remove active state from all buttons
    this.element.querySelectorAll('[data-tab]').forEach(button => {
      button.classList.remove('border-b-2', 'border-yellow-400', 'text-gray-900')
      button.classList.add('text-gray-600')
    })

    // Show selected tab panel
    const selectedPanel = this.element.querySelector(`#tab-${tabValue}`)
    if (selectedPanel) {
      selectedPanel.classList.remove('hidden')
    }

    // Add active state to clicked button
    event.currentTarget.classList.add('border-b-2', 'border-yellow-400', 'text-gray-900')
    event.currentTarget.classList.remove('text-gray-600')
  }

  connect() {
    // ESC key listener
    this.escHandler = (e) => {
      if (e.key === 'Escape' && !this.containerTarget.classList.contains('hidden')) {
        this.close()
      }
    }
    document.addEventListener('keydown', this.escHandler)

    // Click outside listener
    this.containerTarget.addEventListener('click', (e) => this.closeOnBackdrop(e))
  }

  disconnect() {
    document.removeEventListener('keydown', this.escHandler)
    document.body.style.overflow = 'auto'
  }
}
